export const SITE_URL = import.meta.env.VITE_SITE_URL || "https://cubemc.com"; // Important, if changing the canonical site url it must ALSO be changed in ../index.html
export const SITE_LOGO = `${SITE_URL}/logo.png`;
export const OG_IMAGE = `${SITE_URL}/og-image.jpg`;
export const CONTACT_EMAIL = "hello@cubemc.com";
export const PRIVACY_EMAIL = "privacy@cubemc.com";
